import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "row" ]
  static values = { storageKey: String, expandAll: Boolean }

  connect() {
    this.expanded = new Set(this.expandAllValue ? this.rowTargets.map(row => row.dataset.pageId) : this.load())
    this.render()
  }

  rowTargetConnected() {
    if (!this.expanded) return

    cancelAnimationFrame(this.frame)
    this.frame = requestAnimationFrame(() => this.render())
  }

  toggle(event) {
    const id = event.currentTarget.closest("tr").dataset.pageId

    this.expanded.has(id) ? this.expanded.delete(id) : this.expanded.add(id)
    this.save()
    this.render()
  }

  render() {
    const rows = new Map(this.rowTargets.map(row => [ row.dataset.pageId, row ]))

    rows.forEach(row => {
      row.hidden = !this.visible(row, rows)

      const toggle = row.querySelector(".cms-tree-toggle")
      if (toggle) toggle.setAttribute("aria-expanded", this.expanded.has(row.dataset.pageId))
    })
  }

  visible(row, rows) {
    let parentId = row.dataset.parentId

    while (parentId && rows.has(parentId)) {
      if (!this.expanded.has(parentId)) return false
      parentId = rows.get(parentId).dataset.parentId
    }

    return true
  }

  load() {
    try {
      return JSON.parse(sessionStorage.getItem(this.storageKeyValue)) || []
    } catch {
      return []
    }
  }

  save() {
    try {
      sessionStorage.setItem(this.storageKeyValue, JSON.stringify([ ...this.expanded ]))
    } catch {}
  }
}
